import { Component, Injector, Input, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Empenho, Login, PendenciaAssinatura } from 'eddydata-lib';
import { MessageService } from 'primeng/api';
import { PendenciaAssinaturaService } from 'projects/eddydata-lib/src/lib/pendencia-assinatura/service/pendencia-assinatura.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-empenho-historico-assinatura',
  templateUrl: './empenho-historico-assinatura.component.html'
})
export class EmpenhoHistoricoAssinaturaComponent implements OnInit, OnDestroy {


  public pendenciaAssinatura: PendenciaAssinatura[] = [];
  protected unsubscribe: Subject<void> = new Subject();

  @Input() entidade: Empenho;
  @Input() public login: Login;

  public imaskConfig = {
    mask: Number,
    scale: 2,
    thousandsSeparator: '.',
    padFractionalZeros: true,
    normalizeZeros: true,
    radix: ','
  };

  constructor(
    protected injector: Injector,
    protected messageService: MessageService,
    private pendenciaAssinaturaService: PendenciaAssinaturaService) {
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['entidade'] && this.entidade?.id) {
      this.pendenciaAssinaturaService
        .filtrar(1, -1, { id_entidade: this.entidade.id, 'etapa.etapa.nome': 'NOVO_EMPENHO', relations: 'usuario_assinatura,etapa.perfil', orderBy: 'id$DESC' })
        .pipe(takeUntil(this.unsubscribe))
        .subscribe((res) => {
          for (const item of res.content as PendenciaAssinatura[]) {
            if (item.motivo == null && item.status == 'RECUSADO') {
              item.status = 'PENDENTE'
            }
            if (item.motivo != null && item.status == 'PENDENTE') {
              item.status = 'RECUSADO'
            }
            if (item.motivo == null && item.status == 'PENDENTE' && item?.data_assinatura) {
              item.status = 'ASSINADO'
            }
            item.descricao = this.removerJustificativa(item.descricao)
            this.pendenciaAssinatura.push(item);
          }
        }, (res) => {
          toastr.error(res.error.payload);
        });
    }

  }

  public removerJustificativa(texto: string): string {
    const regex = /(.*?)(?:Justificativa:)[\s\S]*/i;
    const match = texto.match(regex);
    return match ? match[1].trim() : texto.trim();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

}